var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAxv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#111130"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 46.5c12.426 0 22.5-10.074 22.5-22.5s-10.074-22.5-22.5-22.5-22.5 10.074-22.5 22.5 10.074 22.5 22.5 22.5zm0 1.5c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z",
    clipRule: "evenodd",
    fill: "url(#paint0_linear_1908_20857)",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.558 24.98-4.313 7.5262h3.8603l2.3713-4.1795z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.531 25.013-0.5364 0.9377-5.8897-10.395h-3.8306l9.7514 16.976 2.4064-4.2013-1.9011-3.3167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.973 15.531-2.3915 4.1755 1.9024 3.3208 0.5202-0.916 5.9384 10.395h3.7819l-9.7514-16.976z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.445 23.074 4.3089-7.5181h-3.8103l-2.4024 4.1973z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1908_20857",
    x2: 48,
    y1: 24,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01EEFD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#073DC8",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAxv);
export default __webpack_public_path__ + "static/media/logo-axv.5f0b26624713d87c354ecf856cf88a28.svg";
export { ForwardRef as ReactComponent };